import {createAsyncThunk} from "@reduxjs/toolkit";
import {setDoc, collection, getDocs, updateDoc, doc, getDoc, query, where} from "firebase/firestore/lite";
import { db } from '../../firebase/client';
import { Test, TestGroup} from "./CreateNewState";
import {getNextOrderNumberByTestGroup} from "./Tests/TestUtil";
import {MessageInstance} from "antd/es/message/interface";
import dbService, {DBType} from "../../services/DB.services";

// Test Group

interface CreateNewTestGroupRequest extends TestGroup {
    isEdit: boolean;
    messageApi: MessageInstance;
    dbType: DBType;
}

export const createNewTestGroup = createAsyncThunk(
    "CreateNewTestGroup",
    async (testGroup: CreateNewTestGroupRequest, thunkArg) => {
        const {
            id,
            title,
            groupType,
            imageUrl,
            image,
            isCompleted,
            order,
            createdAt,
            tests,
            isEdit,
            messageApi,
            dbType,
        } = testGroup;
        const testGroupRequest = {
            title,
            groupType,
            image,
            imageUrl,
            isCompleted,
            order,
            createdAt,
            tests,
        };
        let DB_NAME = dbService.dbNameByType(dbType);

        const testGroupRef = doc(db, DB_NAME, id);
        const docSnap = await getDoc(testGroupRef);
        let group = testGroup;

        const isGroupNameTypeExist = isEdit ? false : await isGroupNameTypeAlreadyExist(title, groupType, dbType);

        if (isGroupNameTypeExist) {
            messageApi.open({
                type: 'error',
                content: `Group type "${groupType}" with title "${title}" already exists!`,
            });

            return null
        }

        if (hasDuplicatedTests(testGroupRequest)) {
            messageApi.open({
                type: 'error',
                content: `Some tests are duplicated!`,
            });

            return null
        }

        if (docSnap.exists()) {
            await updateDoc(testGroupRef, testGroupRequest);
        } else {
            await setDoc(doc(db, DB_NAME, id), {
                ...testGroupRequest,
                id,
            });
        }

        thunkArg.dispatch(requestAllTestGroup(dbType))

        return group;
    })

async function isGroupNameTypeAlreadyExist(title: string, groupType: string, dbType: DBType) {
    const DB_NAME = dbService.dbNameByType(dbType);
    const testGroupRef = collection(db, DB_NAME);
    const q = query(testGroupRef, where("title", "==", title), where("groupType", "==", groupType));
    const querySnapshot = await getDocs(q);

    return querySnapshot.size > 0;
}

function hasDuplicatedTests(testGroup: {
    title: string;
    groupType: string;
    imageUrl?: string;
    isCompleted?: boolean;
    order: number;
    createdAt: Date;
    tests: Test[];
}) {
    const testTitleTestGroupTypeMap: { [key: string]: boolean } = {};
    if (testGroup) {
        return testGroup.tests.some((testItem) => {
            const key = `${testItem.title}-${testGroup.groupType}`

            if (testTitleTestGroupTypeMap[key]) {
                return true;
            }

            testTitleTestGroupTypeMap[key] = true

            return false;
        })
    }

    return false
}

function findDuplicates(ids: string[]) {
    let sortedIds = ids.slice().sort();

    let results = [];
    for (let i = 0; i < sortedIds.length - 1; i++) {
        if (sortedIds[i + 1] == sortedIds[i]) {
            results.push(sortedIds[i]);
        }
    }
    return results;
}

function getAllIds(testGroups: TestGroup[]) {
    const tests: string[] = [];
    const questions: string[] = [];

    testGroups.forEach((testGroup) => {
        // console.log(testGroup.id);

        // if (tests.includes(testGroup.id)) {
        //     console.log("Not unique id: ", testGroup.id)
        // }

        testGroup.tests.forEach((test) => {
            // console.log(test.id);

            if (tests.includes(test.id)) {
                // console.log("Not unique id: ", test.id);
            } else {
                tests.push(test.id);
            }

            test.questions.forEach((question) => {
                if (questions.includes(question.id)) {
                    // console.log("Not unique id: ", test.id);
                } else {
                    questions.push(question.id);
                }
            })
        })
    })

    return  {
        tests,
        questions,
    };
}

export const requestAllTestGroup = createAsyncThunk(
    "requestAllTestGroup",
    async (dbType?: DBType) => {
        const DB_NAME = dbService.dbNameByType(dbType);
        const allTestGroups = await getDocs(collection(db, DB_NAME));
        const testGroupList = allTestGroups.docs.map(doc => doc.data()) as TestGroup[];
        const sortedTestGroups = testGroupList
            .sort((testGroupA, testGroupB) => testGroupA.order - testGroupB.order);

        console.log("Total tests: ", dbType, testGroupList);
        // console.log("Total tests: ", dbType, getAllIds(sortedTestGroups));

        return {
            dbType,
            testGroups: sortedTestGroups,
        };
    })

// Tests

interface AssignTestToTestGroupsPayload {
    test: Test,
    testGroupId: string,
    messageApi: MessageInstance;
    dbType?: DBType;
}

export const assignTestToTestGroups = createAsyncThunk(
    "assignTestToTestGroups",
    async (payload: AssignTestToTestGroupsPayload, thunkArg) => {
        const {dbType, test, testGroupId, messageApi} = payload;
        const DB_NAME = dbService.dbNameByType(dbType);
        const testGroupRef = doc(db, DB_NAME, testGroupId);
        const docSnap = await getDoc(testGroupRef);

        if (docSnap.exists()) {
            const testGroup = docSnap.data() as TestGroup;
            const tests = testGroup.tests ? testGroup.tests : [];
            const isTestAlreadyExists = tests.some((testItem) => {
                const isTitleTheSame = testItem.title === test.title;
                const isTestGroupTheSame = testGroup.id === testGroupId;
                const isIdDifferent = testItem.id !== test.id;

                return isIdDifferent && isTitleTheSame && isTestGroupTheSame;
            });
            const isTestInEditMode = tests.some((testItem) => testItem.id === test.id)
            const skipTests: Test[] = tests.filter((testItem) => testItem.id !== test.id);

            if (isTestAlreadyExists) {
                messageApi.open({
                    type: 'error',
                    content: `Test "${test.title}" for test group "${testGroup.title}" already exists!`,
                });

                return null;
            }

            if (isTestInEditMode) {
                debugger
                await updateDoc(testGroupRef, {
                    tests: [
                        ...skipTests,
                        test
                    ],
                });
            } else {
                debugger
                await updateDoc(testGroupRef, {
                    tests: [
                        ...tests,
                        {
                            ...test,
                            order: test.order ? test.order : getNextOrderNumberByTestGroup(testGroup)
                        }],
                });
            }
        } else {
            throw new Error("Test Group doesn't exists!")
        }

        thunkArg.dispatch(requestAllTestGroup(dbType));

        return null;
    })